(function (app) {

    app.constant("caseTimelineStatusTypes",
        [
            { ShortName: "ApplicationSigned", LongName: "Application Signed" },
            { ShortName: "SubmittedToFIG", LongName: "Submitted to FIG" },
            { ShortName: "SubmittedToCarrier", LongName: "Submitted To Carrier" },
            { ShortName: "Pending", LongName: "Pending" },
            { ShortName: "Approved", LongName: "Approved" },
            { ShortName: "Issued", LongName: "Issued" },
            { ShortName: "Inforce", LongName: "Inforce" },
            { ShortName: "AwaitingFunds", LongName: "Awaiting Funds" },
            { ShortName: "SentToCustodian", LongName: "Sent To Custodian" },
            { ShortName: "AwaitingApproval", LongName: "Awaiting Approval" },
            { ShortName: "OKToTrade", LongName: "OK To Trade" },
            { ShortName: "AddedToTradeSheet", LongName: "Added To Trade Sheet" },
            { ShortName: "Invested", LongName: "Invested" },
            { ShortName: "Blocked", LongName: "Blocked" },
            { ShortName: "Closed", LongName: "Closed" },
            { ShortName: "HoldAccountFunded", LongName: "Hold Account Funded" },
            { ShortName: "PartiallyFunded", LongName: "Partially Funded" }
        ]);

})(window.app); //jshint ignore:line